var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 40.5,
    viewBox: "0 0 64 40.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-data",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 32,
    cy: 7,
    rx: 32,
    ry: 7,
    transform: "translate(0 26)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2777",
    "data-name": "Group 2777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8278",
    "data-name": "Path 8278",
    d: "M55,12.76,44.854,1.258A2.378,2.378,0,0,0,42.907,0H21.093a2.379,2.379,0,0,0-1.947,1.257L9,12.761V22H55Z",
    fill: "none",
    stroke: "#c7c7c7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8279",
    "data-name": "Path 8279",
    d: "M41.613,15.931c0-1.6.994-2.93,2.227-2.931H55V31.137C55,33.26,53.68,35,52.05,35H11.95C10.32,35,9,33.259,9,31.137V13H20.16c1.233,0,2.227,1.323,2.227,2.928v.022c0,1.605,1,2.9,2.237,2.9H39.376c1.232,0,2.237-1.308,2.237-2.913Z",
    fill: "#fafafa",
    stroke: "#c7c7c7",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.79d80bdb28a67698c2cc15b991d15258.svg";
export { ForwardRef as ReactComponent };